import { TabEnum } from 'Common/Constants/Enumeration/KitchenPrepWorksheet';
import * as types from './types';

const INITIAL_STATE = {
  selectedTab: TabEnum.Available,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.KITCHEN_PREP_SET_SELECTED_TAB:
      return {
        ...state,
        selectedTab: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/centralkitchen/kitchenprepworksheet/state/settings/reducer.js